module.exports = __webpack_public_path__ + "static/media/ncj_bangle_0006.9649ed9f.jpg";